<template>
  <div class="pix-card-container">
    <h1>Meio de pagamento - Pix</h1>

    <div v-if="hasQrCode" class="content has-qr-code">
      <div class="instructions-container">
        <div class="title">
          Como realizar o pagamento:
        </div>

        <div class="step-container">
          <div v-for="(item, index) in steps" :key="index" class="step">
            <div class="number-container">
              <div class="number">
                {{ item.step }}
              </div>
            </div>

            <div class="text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>

      <div class="qr-code-card-container">
        <qr-code-card-component
          :emvValue="emv"
          :hasQrCodeRequest="hasRequest"
        />
      </div>
    </div>

    <div v-else class="content">
      <div class="value-output">
        Valor total

        <div class="value">
          {{ data.formattedDiscountAmount }}
        </div>
      </div>

      <div class="button-container">
        <button-component
          class="button"
          text="Gerar QR Code"
          :hasLoader="hasRequest"
          :isDisabled="hasRequest"
          @click.native="generateQrCode"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import Button from '@/components/Button';
  import QrCodeCard from '@/components/QrCodeCard';

  export default {
    name: 'PixPaymentCard',

    data() {
      return {
        hasQrCode: false,
        hasRequest: false,
        resData: {},
        pixTransactionStatus: null,
        emv: '',
        steps: [
          {
            text: 'Abra o aplicativo do seu banco ou instituição finaceira e selecione Pix',
            step: 1
          },
          {
            text: 'Escaneie o QR Code ou a use a opção copia e cola',
            step: 2
          },
          {
            text: 'Cofirme as informações e finalize o pagamento',
            step: 3
          }
        ]
      };
    },

    props: {
      data: {
        type: Object,
        default() {
          return {
            formattedDiscountAmount: 'R$ 0,00',
            discountAmount: 0
          };
        }
      }
    },

    components: {
      'button-component': Button,
      'qr-code-card-component': QrCodeCard
    },

    computed: {
      ...mapGetters([
        'getCurrentDebtId'
      ]),

      ...mapState({
        checkoutStatus: state => state.checkoutStatus,
        qrCodeIsExpired: state => state.qrCodeIsExpired,
        paymentData: state => state.data,
        successPaymentCardData: state => state.successPaymentCardData
      })
    },

    watch: {
      qrCodeIsExpired(value) {
        if(!value) {
          this.setPayment();
        }
      }
    },

    methods: {
      generateQrCode() {
        this.$store.commit('setSecondStepStatus', 'check');
        this.setPayment();
      },

      setPayment() {
        this.hasRequest = true;

        this.$store.dispatch('getDebtId', this.getCurrentDebtId)
          .then(res => {
            if (this.$service.toUpperCase(res.data.StatusPagamento) == 'PAGO') {
              this.checkoutStatus.isPayment = false;
            } else {
              this.$store.commit('setQrCodeIsExpired', false);
              this.createPayment();
            }
          });
      },

      async createPayment() {
        this.hasRequest = true;

        let paymentData = {
          payment: {
            method: 'Pix'
          }
        };

        await this.$store.dispatch('setPayment', paymentData)
          .then(res => {
            this.hasQrCode = true;
            this.checkoutStatus.isPayment = true;
            this.emv = res.data.payment.pix.qr_code.emv;
            this.paymentData.installments.numberOfInstallments = 1;
            this.verifyPaymentStatus();
          })
          .catch(err => {
            this.checkoutStatus.isPayment = false;
            this.checkoutStatus.isPixPaymentError = true;
            this.checkoutStatus.isExpired = false;

            if (err.data.status === 419) {
              this.checkoutStatus.isExpired = true;
            }
          });

        this.hasRequest = false;
      },

      verifyPaymentStatus() {
        this.$store.commit('setQrCodeIsExpired', false);

        this.pixTransactionStatus = setInterval(async() => {
          await this.$store.dispatch('getDebtId', this.getCurrentDebtId)
            .then(res => {
              this.resData = res.data;

              let isExpiredPix = this.resData.transaction.payment.pix.is_expired;

              if (this.resData.is_expired) {
                this.checkoutStatus.isExpired = true;
              }

              if (this.resData.transaction != null && this.resData.transaction.status === 'Succeeded' && !isExpiredPix) {
                this.checkoutStatus.isPayment = false;
                this.checkoutStatus.isSuccessPayment = true;
                this.successPaymentCardData.transaction.id = this.resData.transaction.id;
                this.successPaymentCardData.transaction.date = this.$service.dateFormat(this.resData.transaction.updated_at, 'DD/MM/YYYY HH:mm:ss');
              } else if (isExpiredPix) {
                this.$store.commit('setQrCodeIsExpired', true);
                clearInterval(this.pixTransactionStatus);
              }
            })
            .catch(() => {
              this.$store.commit('setQrCodeIsExpired', true);
              clearInterval(this.pixTransactionStatus);
            });
        }, 5000);
      }
    },

    beforeDestroy() {
      clearInterval(this.pixTransactionStatus);
    }
  };
</script>

<style lang="scss" scoped>
  .pix-card-container {
    padding: 1.5rem;
    background: #efefef;
    width: 100%;
    border-radius: 1.5rem;

    h1 {
      font-size: 1.2rem;
      font-weight: 600;
    }

    .content {
      margin-top: 1.5rem;
      display: flex;

      &.has-qr-code {
        .instructions-container {
          font-size: 14px;

          .title {
            font-weight: 500;
            font-size: 16px;
          }

          .step-container {
            margin-top: 0.5rem;
            padding: 1rem;

            .step {
              display: flex;
              margin-bottom: 1rem;

              .number-container {
                .number {
                  color: #FFF;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-weight: 600;
                  height: 25px;
                  width: 25px;
                  background: #ff9c00;
                  border-radius: 100%;
                }
              }

              .text {
                margin-left: 0.5rem;
              }
            }
          }
        }

        .qr-code-card-container {
          margin-left: 3rem;
          align-items: center;
          justify-content: center;
          display: flex;
        }

        .logo-pix {
          margin-top: 2rem;
          justify-content: center;
          align-items: center;
          display: flex;

          img {
            width: 145px;
          }
        }
      }

      .value-output {
        margin-right: 1rem;

        .value {
          padding: 1rem;
          width: 15rem;
          height: 48px;
          background: #dadada;
          border-radius: 0.5rem;
          margin-top: 0.5rem;
          font-weight: 600;
          display: flex;
          align-items: center;
        }
      }

      .button-container {
        display: flex;
        align-items: flex-end;
        width: 15rem;

        .button {
          border-radius: 0.5rem;
          width: 100%;
          height: 48px;
        }
      }

      .pix-card-container {
        display: flex;
        justify-content: center;
      }
    }
  }

  @media (max-width: 1215px) {
    .pix-card-container {
      .content {
        flex-direction: column;

          &.has-qr-code {
            .qr-code-card-container {
              margin-left: unset;
              margin-top: 0.5rem;
            }
          }

        .button-container {
          margin-top: 1rem;
        }
      }
    }
  }

  @media (max-width: 520px) {
    .pix-card-container {
      .content {
        &.has-qr-code {
          .instructions-container {
            font-size: 12px;

            .title {
              font-size: 14px;
            }

            .step-container {
              .step {
                .number-container {
                  .number {
                    height: 20px;
                    width: 20px;
                  }
                }
              }
            }
          }
        }

        .value-output {
          margin-right: unset;
          font-size: 12px;

          .value {
            font-size: 16px;
            width: 100%;
          }
        }

        .button-container {
          width: 100%;
        }
      }
    }
  }
</style>